<template>
<div class="findpasswordresetPage" id="">  
  <XR-head titleText="手机重置密码" :rightShow="false" ref="head"></XR-head>
  <div class="login-form">
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33">
      <mu-text-field label="新密码" icon=":fa fa-lock" type="password" labelFloat fullWidth v-model="resetInfo.newPassword" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33">
      <mu-text-field label="重复密码" helpText="请再次输入新密码" icon=":fa fa-lock" type="password" labelFloat fullWidth v-model="resetInfo.confrimNewPassword" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="login-div">
      <mu-raised-button label="确 定" class="demo-raised-button" primary fullWidth @click="Reset()" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div3">
      <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
    </mu-col>
  </mu-row>
</div>
</div>
</template>
<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      resetInfo: {
        mobile:this.$route.query.mobile,
        smsCode:this.$route.query.smsCode,
        newPassword:'',
        confrimNewPassword:''
      }
    }
  },
  methods: {
    Reset: function () {
      const ths = this;   
      if(!ths.resetInfo.newPassword) {
        ths.$refs.XRtoast.failed('请输入新密码', true)
        return
      }
      if(ths.resetInfo.confrimNewPassword!=ths.resetInfo.newPassword){
        ths.$refs.XRtoast.failed('二次输入的密码不一致', true)
        return
      }

      this.$post('/Shop/UserServer/MobileFindPasswordReSetPassword', JSON.stringify(this.resetInfo))
        .then(function (res) {
          ths.resetInfo.newPassword = ''
          ths.resetInfo.confrimNewPassword = ''
          if(res.IsSuccess){
            ths.$refs.XRtoast.success(res.Msg, true)
          }else{
            ths.$refs.XRtoast.failed(res.Msg, true)
          }
        })
        .catch(function (err) {
          console.log(err)
        })      
    },
    goBack(){
      this.$router.push("/login")
    }
  }
}

</script>
<style>
body .findpasswordresetPage{
  background: white;
}
.findpasswordresetPage .login-form {
  padding: 10px 20px 20px 10px;
}
.findpasswordresetPage .login-div {
  padding: 40px 0px 0 20px;
}
.findpasswordresetPage .demo-raised-button {
  height: 50px;
}
.findpasswordresetPage .div2 {
  padding: 20px 0 0 0;
}
.findpasswordresetPage .demo-flat-button.right {
  float: right;
}
.findpasswordresetPage .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}

.findpasswordresetPage .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/findPasswordReset.vue